// NFKC (composed)             // (decomposed)

/**
 *  A constant for the ether symbol (normalized using NFKC).
 *
 *  (**i.e.** ``"\\u039e"``)
 */
export const EtherSymbol: string = "\u039e";  // "\uD835\uDF63";


/**
 *  A constant for the [[link-eip-191]] personal message prefix.
 *
 *  (**i.e.** ``"\\x19Ethereum Signed Message:\\n"``)
 */
export const MessagePrefix: string = "\x19Ethereum Signed Message:\n";
